<div class="shift" *ngFor="let shift of shifts" [style.flex-grow]="shift.durationInMinutes" [class.empty-space]="!shift.name" [class.alternate]="shift.alternate" [matTooltip]="shift.name"></div>
